import { render } from "./loadtabxls.vue?vue&type=template&id=7f5229db"
import script from "./loadtabxls.vue?vue&type=script&lang=js"
export * from "./loadtabxls.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/fields/loadtabxls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f5229db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f5229db', __exports__)) {
    console.log('reload')
    api.reload('7f5229db', __exports__)
  }
  
  module.hot.accept("./loadtabxls.vue?vue&type=template&id=7f5229db", () => {
    console.log('re-render')
    api.rerender('7f5229db', render)
  })

}


export default __exports__